import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import { Button, Overlay } from 'react-bootstrap';
import { LabelWithArrow } from './basic';
import { CheckBox } from './forms';
import '../../public/less/multiSelect.less';

class ListItem extends Component {
    constructor(props) {
        super(props);

        this.state = {
            val: this.props.val
        };

        this.checkBoxClick = this.checkBoxClick.bind(this);
    }

    checkBoxClick(evt) {
        this.setState({
            val: evt.target.value
        });

        this
            .props
            .onChange(evt.target.value);
    }

    render() {
        var item = this.props.item;

        var isChecked = item.isChecked ? item.isChecked : false;
        if (this.state.val == item.id) {
            isChecked = true;
        }

        return (
            <span>
                <input onChange={this.checkBoxClick.bind(this)} type='radio' value={item.id} checked={isChecked} id={this.props.id} name={this.props.id} />{item.value}<br />
            </span>
        );
    }
};

class CustomPopover extends Component {
    constructor(props) {
        super(props);

        this.state = {
            val: this.props.val
        };

        this.onChange = this.onChange.bind(this);
    }

    onChange(val) {
        this.setState({ val: val });

        this.props.onChange(val);
    }

    render() {
        var id = this.props.id;
        var val = this.state.val;
        var onChange = this.onChange;
        var lines = this
            .props
            .Items
            .map(function (item, i) {
                return (<ListItem item={item} key={i} onChange={onChange} id={id} val={val} />);
            });
        return (
            <div className='dropDownPopover'>
                {lines}
            </div>
        );
    }
};

module.exports = class DropDown extends Component {
    constructor(props) {
        super(props);

        this.valuesWithProp = [];
        for (var i in this.props.Data) {
            var isChecked = this.props.Data[i].isChecked ? this.props.Data[i].isChecked : false;
            this
                .valuesWithProp
                .push({
                    isChecked: isChecked,
                    value: this.props.Data[i].name,
                    id: this.props.Data[i].id
                });
        }

        this.state = {
            show: false,
            data: this.valuesWithProp,
            val: this.props.value
        }

        this.onChange = this.onChange.bind(this);
    };

    changeData(data) {
        this.valuesWithProp = [];
        for (var i in data) {
            var isChecked = data[i].isChecked ? data[i].isChecked : false;
            this
                .valuesWithProp
                .push({
                    isChecked: isChecked,
                    value: data[i].name,
                    id: data[i].id
                });
        }

        this.setState({ data: this.valuesWithProp });
    }

    show(val) {
        if (val != undefined && typeof (val) === "boolean") {
            this.setState({ show: val });
        } else {
            var show = this.state.show;
            this.setState({
                show: !show
            });
        }
    };

    onChange(val) {
        this.setState({
            val: val,
            show: false
        });

        if (this.props.onChange) {
            this.props.onChange(val);
        }
    }

    update(val) {
        this.setState({
            val: val
        });
    }

    render() {
        var newLabel;
        var val = this.state.val;
        var inputVal = this.props.ID + "_val";
        if (val) {
            if (this.props.addLabelWhenChosen) {
                newLabel = val + this.props.addLabelWhenChosen;
            }
            else {
                newLabel = this.props.Label + "(" + val + ")";
            }
        }
        else {
            newLabel = this.props.Label;
        }
        return (
            <div className='multiSelect'>
                <div className='multiSelectTrigger'>
                    <label
                        className='h4'
                        ref="target"
                        onClick={this
                            .show
                            .bind(this)}><LabelWithArrow Label={newLabel} className="" /></label>
                    <input type='hidden' id={inputVal} name={inputVal} value={this.state.val} />
                    <Overlay
                        show={this.state.show}
                        animation={false}
                        onHide={() => this.setState({ show: false })}
                        placement="bottom"
                        container={this}
                        rootClose={true}
                        target={() => ReactDOM.findDOMNode(this.refs.target)}>
                        <CustomPopover Items={this.state.data} onChange={this.onChange} id={this.props.id} val={this.state.val} />
                    </Overlay>
                </div>
            </div>
        )
    }
};



// WEBPACK FOOTER //
// ./modules/common/dropDownOne.jsx